import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

export function InvestorPortalHeader() {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white border-b border-slate-300 px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-[#007ACC] rounded-md flex items-center justify-center">
          <span className="text-white font-bold text-sm">OPG</span>
        </div>
        <span className="text-xl font-bold text-slate-900">OnPoint Generators</span>
        <span className="hidden sm:inline text-sm text-slate-400">|</span>
        <span className="hidden sm:inline text-sm text-slate-500">Investor Portal</span>
      </div>
      <div className="flex items-center gap-4">
        <span className="hidden sm:block text-sm text-slate-600">{user?.displayName}</span>
        <button
          onClick={logout}
          className="text-sm text-slate-500 hover:text-slate-700 transition-colors"
        >
          Log Out
        </button>
      </div>
    </header>
  );
}
